export class CreateKitOrderLayout{
    public assembly_part: string;
    public fromInStatus: string;
    public toInvStatus: string;
    public orderQty: string;

    constructor(){
        this.assembly_part = "";
        this.fromInStatus = "";
        this.toInvStatus = "";
        this.orderQty = "";
    }

}